import { render, staticRenderFns } from "./ReservationContainer.vue?vue&type=template&id=6180aa38&"
import script from "./../../componentScripts/reservationContainer.js?vue&type=script&lang=js&"
export * from "./../../componentScripts/reservationContainer.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports